module.exports = __webpack_public_path__ + "img/banner-01.bd52f1a3.jpg";